import { Toaster } from '@talentmesh/ui/components/sonner';
import { ReactNode } from 'react';
import { NotificationProvider } from '@/Context/NotificationContext';

export interface NotificationSystemProps {
    children: ReactNode;
}

function NotificationSystem({ children }: NotificationSystemProps) {
    return (
        <NotificationProvider>
            {children}
            <Toaster position="bottom-left" closeButton />
        </NotificationProvider>
    );
}

export default NotificationSystem;
